import React, { Component } from 'react';
import autoBind from 'react-autobind';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import Typography from '@material-ui/core/Typography';
import Avatar from '@material-ui/core/Avatar';
import classNames from 'classnames';
import Button from '@material-ui/core/Button';
import Chip from '@material-ui/core/Chip';
import links from 'utils/links';
import { Link } from 'react-router-dom';

const styles = theme => ({
  card: {
    paddingTop: theme.spacing.unit + 2,
    backgroundColor: '#fff',
    width: "100%"
  },
  imageContainer: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    float: 'left',
    paddingRight: theme.spacing.unit * 2 + 4,
    paddingLeft: theme.spacing.unit * 2 + 4,
    paddingTop: '40px',
    paddingBottom: '40px',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    border: '2px solid #808080',
    borderRadius: '50%',
  },
  avatar: {
    margin: 3,
  },
  bigAvatar: {
    width: '70px',
    height: '70px',
    backgroundColor: '#d5d5d54a',
  },
  member_name: {
    textAlign: 'center',
  },
  button: {
    // margin: theme.spacing.unit,
    margin: '20px 0 20px 0',
    backgroundColor: theme.palette.ternary.dark,
  },
  cuisineBtnBox: {
    display: 'flex',
    justifyContent: 'center',
    flexWrap: 'wrap',
  },
  cuisineButton: {
    height: '25px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: '5px',
    backgroundColor: '#eceaea',
    margin: theme.spacing.unit - 3,
    border: '0px',
  },
  chip: {
    margin: theme.spacing.unit,
  },
  followText: {
    marginBottom: '30px',
  },
});

class FollowersCard extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
  }
  render() {
    const {
      classes,
      expertsIn,
      username,
      // followed,
      id,
      profilePic,
      articleCount,
    } = this.props;
    return (
      <Card className={classes.card}>
        <div className={classes.imageContainer}>
          <div className={classes.row}>
            <a
              href={links.contributorProfileLinks(id)}
              target="_blank"
              rel="noopener noreferrer"
            >
              <Avatar
                alt="Adelle Charles"
                src={profilePic ? profilePic : '/icons/user.png'}
                className={classNames(classes.avatar, classes.bigAvatar)}
              />
            </a>
          </div>
          <a
            href={links.contributorProfileLinks(id)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Typography
              className={classes.member_name}
              component="h3"
              variant="h6"
            >
              {username}
            </Typography>
          </a>
          {articleCount > 0 ? (
            <Typography className={classes.pos} color="textSecondary">
              {articleCount} articles
            </Typography>
          ) : (
              ''
            )}
          <div className={classes.cuisineBtnBox}>
            {expertsIn
              ? expertsIn.map(cuisine => {
                return (
                  <Chip
                    label={cuisine.name}
                    className={classes.cuisineButton}
                    key={cuisine.id}
                    variant="outlined"
                  />
                );
              })
              : ''}
          </div>
          <Link
            to={links.contributorProfileLinks(id)}
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              variant="contained"
              color="secondary"
              className={classes.button}
            >
              View Profile
            </Button>
          </Link>
        </div>
      </Card>
    );
  }
}

FollowersCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(FollowersCard);
